import * as React from "react";
import * as Constants from "../../core/constants";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import deleteIcon from "../../iconic/delete.svg";

interface IRecipientInputProps extends ITranslationProps {
    id: string;
    value: string;
    countryCode: string;
    type: string;
    onChange: (id: string, value: string, countryCode: string) => void;
    onDelete: (id: string) => void;
}

function RecipientInput(p: IRecipientInputProps) {

    function onFieldChange(event: React.ChangeEvent<HTMLInputElement>) {
        p.onChange(p.id, event.target.value, p.countryCode);
    }

    function onCountryCodeChange(event: React.ChangeEvent<HTMLInputElement>) {
        p.onChange(p.id, p.value, event.target.value);
    }

    function onDeleteClick() {
        p.onDelete(p.id);
    }

    const isPhone: boolean = p.type !== Constants.MESSAGE_TYPE_EMAIL;

    return (
        <div className="mb-1 row">

            {isPhone &&
                <div className="col-sm-2 pr-1">
                    <input data-id="country-code" className="form-control" type="text" onChange={onCountryCodeChange}
                        value={p.countryCode} required={true} maxLength={4} pattern="[0-9]*"
                        placeholder={p.t("SendMessage.CountryCode")} />
                    <div className="invalid-feedback">
                        {p.t("SendMessage.CountryCodeInvalid")}
                    </div>
                </div>
            }
            <div className={isPhone ? "col pl-0" : "col"}>
                <div className="input-group">

                    {isPhone &&
                        <input className="form-control" type="tel"
                            pattern="[0-9]*"
                            onChange={onFieldChange} value={p.value} required={true}
                            placeholder={p.t("Phone Number")} />
                    }

                    {!isPhone &&
                        <input className="form-control" type="email"
                            onChange={onFieldChange} value={p.value} required={true}
                            placeholder={p.t("Email Address")} />
                    }

                    <div className="input-group-append">
                        <button type="button" className="btn btn-outline-secondary pt-0" title={p.t("Global.Delete")}
                            onClick={onDeleteClick}>
                            <img className="button-icon" src={deleteIcon} />
                        </button>
                    </div>
                    <div className="invalid-feedback">
                        {isPhone ? p.t("SendMessage.PhoneNumberInvalid") : p.t("SendMessage.EmailInvalid")}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default translateComponent(RecipientInput);



// WEBPACK FOOTER //
// ./src/components/SendMessage/RecipientInput.tsx